import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './index.scss';
import Badge from '../badge/index';
import TabButton from '../tab-button/index';

const Header = ({ headerTitle = '', licenceSummaryTitle, licenceSummary, tabs }) => (
    <div className={css.headerComponent}>
        <div className={css.headerText}>{headerTitle}</div>
        <div className={css.tabContainer}>
            {
                tabs.map((val, index) =>
                    <TabButton key={val.id} name={val.name} route={val.route} tabIndex={index} />
                )
            }
        </div>
        <div className={css.badgeContainer}><Badge badgeStyle={css.licenceCount} content={licenceSummary} showLoader title={licenceSummaryTitle} /></div>
    </div>
);

Header.propTypes = {
    headerTitle: PropTypes.string,
    licenceSummaryTitle: PropTypes.string,
    licenceSummary: PropTypes.string,
    tabs: PropTypes.array
};

export default styleable(css)(Header);



// WEBPACK FOOTER //
// ./app/components/header/index.js